import { type UUID } from '~/types/common';

import {
  entries,
  filter,
  fromEntries,
  isPlainObject,
  map,
  pipe,
  toCamelCase,
} from '@vestigas/utils';

import { type DeliveryNoteAdmin } from '../types';

import { getCreatorId } from './getCreatorId';

/**
 * Extracts the UUIDs of the users that have changed the process state and the respective process state from a delivery note.
 * @param deliveryNote - The delivery note to extract the process state change user IDs from.
 * @returns An object with the process state change user IDs.
 */
export const getProcessStateChangeUserIds = (
  deliveryNote: DeliveryNoteAdmin,
): Record<string, UUID | undefined> => {
  if (!isPlainObject(deliveryNote)) {
    return {};
  }

  const userIds = pipe(
    entries(deliveryNote),
    filter(([key]) => /^us[A-Z]/.test(key)), // keys like usReadyForOutput, usArrived, etc.
    map(([key, value]) => [
      toCamelCase(key.replace(/^us/, '')),
      getCreatorId(value),
    ]),
    fromEntries,
  );

  return userIds;
};
